import { render, staticRenderFns } from "./Registerpopup.vue?vue&type=template&id=1e89698e&"
import script from "./Registerpopup.vue?vue&type=script&lang=js&"
export * from "./Registerpopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports